import React from "react";
import Header from "../components/Header";
import Form from "../components/Form";
import BackToTopButton from "../components/BackToTopButton";
const Home = () => {
  return (
    <div>
      <Header />
      <Form />
      <BackToTopButton />
    </div>
  );
};
export default Home;
